export default "__VITE_ASSET__D2ss5JMd__"